// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_widget_leaderboard_tab = /** @type {(inputs: {}) => string} */ () => {
	return `Tabla de posiciones`
};

const ko_widget_leaderboard_tab = /** @type {(inputs: {}) => string} */ () => {
	return `순위표`
};

const lv_widget_leaderboard_tab = /** @type {(inputs: {}) => string} */ () => {
	return `Līderu tabula`
};

/** @type {(inputs: {}) => string} */
const en_widget_leaderboard_tab = () => 'widget_leaderboard_tab'

/** @type {(inputs: {}) => string} */
const de_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const fr_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const fi_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const hi_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const ja_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const nl_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const pt_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const ro_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const th_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const ur_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const zh_hant1_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const da_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const it_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const vn_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const tr_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const ar_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const bs_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const sl_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const id_widget_leaderboard_tab = en_widget_leaderboard_tab;

/** @type {(inputs: {}) => string} */
const sv_widget_leaderboard_tab = en_widget_leaderboard_tab;

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_tab = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_tab(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_tab", locale)
	if (locale === "en") return en_widget_leaderboard_tab(inputs)
	if (locale === "de") return de_widget_leaderboard_tab(inputs)
	if (locale === "es") return es_widget_leaderboard_tab(inputs)
	if (locale === "fr") return fr_widget_leaderboard_tab(inputs)
	if (locale === "fi") return fi_widget_leaderboard_tab(inputs)
	if (locale === "hi") return hi_widget_leaderboard_tab(inputs)
	if (locale === "ja") return ja_widget_leaderboard_tab(inputs)
	if (locale === "nl") return nl_widget_leaderboard_tab(inputs)
	if (locale === "pt") return pt_widget_leaderboard_tab(inputs)
	if (locale === "ro") return ro_widget_leaderboard_tab(inputs)
	if (locale === "th") return th_widget_leaderboard_tab(inputs)
	if (locale === "ur") return ur_widget_leaderboard_tab(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_tab(inputs)
	if (locale === "da") return da_widget_leaderboard_tab(inputs)
	if (locale === "it") return it_widget_leaderboard_tab(inputs)
	if (locale === "vn") return vn_widget_leaderboard_tab(inputs)
	if (locale === "ko") return ko_widget_leaderboard_tab(inputs)
	if (locale === "tr") return tr_widget_leaderboard_tab(inputs)
	if (locale === "lv") return lv_widget_leaderboard_tab(inputs)
	if (locale === "ar") return ar_widget_leaderboard_tab(inputs)
	if (locale === "bs") return bs_widget_leaderboard_tab(inputs)
	if (locale === "sl") return sl_widget_leaderboard_tab(inputs)
	if (locale === "id") return id_widget_leaderboard_tab(inputs)
	if (locale === "sv") return sv_widget_leaderboard_tab(inputs)
	return "widget_leaderboard_tab"
};